(() => {
  const roots = document.querySelectorAll('[data-gos-faq-root]');
  roots.forEach(root => {
    const input = root.querySelector('[data-gos-faq-search]');
    const items = [...root.querySelectorAll('[data-gos-faq-item]')];
    const topics = [...root.querySelectorAll('[data-gos-faq-topic]')];
    const empty = root.querySelector('[data-gos-faq-empty]');
    let activeTopic = 'all';

    const normalize = value => String(value || '').toLowerCase().replace(/\s+/g,' ').trim();
    const apply = () => {
      const q = normalize(input?.value);
      let visible = 0;
      items.forEach(item => {
        const text = normalize(item.textContent);
        const category = item.dataset.faqCategory || 'general';
        const topicMatch = activeTopic === 'all' || category === activeTopic;
        const searchMatch = !q || text.includes(q);
        item.hidden = !(topicMatch && searchMatch);
        if (!item.hidden) visible++;
      });
      empty?.classList.toggle('is-visible', visible === 0);
    };

    input?.addEventListener('input', apply);
    topics.forEach(button => button.addEventListener('click', () => {
      activeTopic = button.dataset.gosFaqTopic || 'all';
      topics.forEach(b => b.classList.toggle('is-active', b === button));
      apply();
    }));
  });
})();
